<template>
    <div class="news-block__cards-filter" >
        <select @change="this.$emit('update', selected)" v-model="selected">
            <option value="">{{ category.title }}</option>
            <template v-for="(service, index) in category.services" :key="`${index}-${service.id}-group`">
                <option :value="service.id" v-show="category.title !== 'Regions'">{{ service.title }}</option>
                <option v-for="(child, index) in service.children" :key="`${index}-${child.id}-input`" :value="child.id"><span v-if="category.title !== 'Regions'">&nbsp;&nbsp;</span>{{ child.title }}</option>
            </template>
        </select>
        <i class="icon-chevron-down"></i>
    </div>
</template>

<script>

export default {
    props: ["category", "selectedValue"],
    data() {
        return {
            selected: ''
        }
    },
    mounted() {
        this.selected = this.selectedValue;
    },
    watch: {
        selectedValue() {
            this.selected = this.selectedValue
        }
    }
}
</script>

